// ignore-string-externalization

/* eslint-disable import/prefer-default-export */

import styled from 'styled-components';
import {
  screenLgMin,
  screenSmMin,
  spacer20,
  spacer80,
} from '@spotify-internal/encore-web-v5';

export const SectionBlog = styled.div`
  .hero {
    margin-bottom: 0;
  }

  time {
    display: block;
    text-transform: uppercase;
    font-size: 14px;
    letter-spacing: 0.16em;

    @media (min-width: ${screenSmMin}) {
      font-size: 12px;
    }
  }
`;

export const Spacer = styled.div`
  height: ${spacer80};

  @media (max-width: ${screenLgMin}) {
    height: ${spacer20};
  }
`;
